import {
  ChamberAccountRoleEnum,
  UserType,
} from "../../../../../graphql/types";

export type ChamberStaffIdentityFields = {
  userType: UserType;
  chamberAccountRole: ChamberAccountRoleEnum;
};

/**
 * Permission controls must never render for the chamber owner, even if an
 * unexpected backend response includes a non-staff account.
 */
export const isManageableChamberStaffUser = (
  user: ChamberStaffIdentityFields
): boolean =>
  user.userType === UserType.ChamberStaff &&
  user.chamberAccountRole === ChamberAccountRoleEnum.Staff;

/**
 * CMP Dashboard (24) "Permanently Disabled": a finished delete. The row keeps
 * the name, job title and permissions view only; the email is erased (IF12 S2).
 */
export const isPermanentlyDisabledStaffUser = (user: {
  accountStatus: string;
  deletedAtUtcMilli?: number | null;
}): boolean =>
  user.accountStatus === "DELETION_PENDING" &&
  typeof user.deletedAtUtcMilli === "number";
